import { isStringNullOrWhiteSpace } from 'owa-localize';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import { ISuggestionModel } from 'office-ui-fabric-react/lib/Pickers';
import parseOneOffEmailAddressFromString from 'owa-recipient-email-address/lib/utils/parseOneOffEmailAddressFromString';
import getDisplayNameAndAddressFromRecipientString from 'owa-recipient-email-address/lib/utils/getDisplayNameAndAddressFromRecipientString';

export default function createGenericItem(
    name: string,
    currentValidationState: boolean
): ISuggestionModel<FindRecipientPersonaType> {
    if (!isStringNullOrWhiteSpace(name)) {
        let nameAndAddress = getDisplayNameAndAddressFromRecipientString(name);
        const parsedRecipientEmail = parseOneOffEmailAddressFromString(
            nameAndAddress.address,
            nameAndAddress.displayName
        );

        if (!parsedRecipientEmail) {
            return null;
        }

        return {
            selected: false,
            item: {
                EmailAddress: parsedRecipientEmail,
            },
        };
    } else {
        return null;
    }
}
